import { Component, For, JSX, Show, createEffect, createMemo, createSignal } from "solid-js";
import { useTable } from "../TableContext";
import style from '../st-table.module.css'
import { Row } from "./Row";
import { Cell } from "./Cell";

interface BodyProps<T extends object = any> {
    load?: (page: number, filters: Record<string, any>) => Promise<T[]>
    children?: JSX.Element | Component<T>
}

export const Body = <T extends object = any,>(props: BodyProps<T>) => {
    const table = useTable();
    const [rows, setRows] = createSignal<T[]>([]);

    createEffect(async () => {
        if (props.load) {
            table.setLoading(true);

            try {
                const data = await props.load(table.page(), {});
                setRows(data);
            } catch(e) {

            }

            table.setLoading(false);
        }
    })

    const c = createMemo(() => {
        if (typeof props.children === 'function') {
            const f = props.children as Component<T>;
            return (
                <For each={rows()}>
                    {row => f(row)}
                </For>
            );
        }

        return props.children as JSX.Element;
    })

    const Loading = () => {
        return (
            <Row>
                <Cell style='grid-column-start: 1; grid-column-end: -1;'>
                    <div class='flexbox middle' style='height: 300px; width: 100%; justify-content: center; gap: 1rem;'>
                        <div>
                            <i class='fa fa-spinner fa-spin' style='font-size: 5rem'></i>
                        </div>
                        <div style='font-size: 1.3rem;'>Loading...</div>
                    </div>
                </Cell>
            </Row>
        )
    }

    return (
        <tbody class={style['st-table-body']}>
            <Show when={!table.loading()} fallback={<Loading />}>
                {c()}
            </Show>
        </tbody>
    )
}